import 'moment/locale/ru'
import res from './res'

res.add('en', {
    newsTitle: 'News feed',
    noDataLable: 'No Data'
})
